import gql from "graphql-tag"

export default gql`
  mutation($companySizeId: String, $industryId: String) {
    updateBenchmarkSettings(
      companySizeId: $companySizeId
      industryId: $industryId
    ) {
      success
      payload
    }
  }
`
